/**
 * Copyright 2019 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useYmmeEngines } from '../api/getYmmeEngines';
import { usePageType } from '@/features/category/api/getPageType';
import { useLegacyRouter } from '@/hooks/useLegacyRouter';
import { useSearchProductData } from '@/features/search/api/getSearchProductData';

export function useYmmeDefaultData() {
  const router = useLegacyRouter();
  const isSearchPage = router.pathname.includes('/searchresult');
  const { data: pageTypeData } = usePageType();
  const { data: searchProductData } = useSearchProductData({ enabled: isSearchPage });

  const makeName = pageTypeData?.make ?? (isSearchPage ? searchProductData?.makeName : undefined);
  const modelName =
    pageTypeData?.model ?? (isSearchPage ? searchProductData?.modelName : undefined);
  // rawYear is usually a number type, when used for comparison, it should be converted to string type
  const rawYear = pageTypeData?.year ?? (isSearchPage ? searchProductData?.makeYear : undefined);
  const year = rawYear ? String(rawYear) : undefined;

  const isSearchDerived =
    isSearchPage && !pageTypeData?.make && !pageTypeData?.model && !pageTypeData?.year;

  const { data: engines } = useYmmeEngines({
    vehicleMakeName: makeName,
    vehicleModelName: modelName,
    vehicleYear: year || undefined,
    modelId: modelName,
    enabled: Boolean(year && modelName && makeName),
  });
  const defaultEngine = engines && engines.length === 1 ? engines[0] : null;

  return {
    data: {
      defaultEngine,
      defaultModel: modelName
        ? {
            value: modelName,
            label: modelName,
          }
        : null,
      defaultSubModel: null,
      defaultMake: makeName ? { value: makeName, label: makeName } : null,
      defaultYear: year,
      isSearchDerived,
    },
  };
}
